import { ThankYouComposer } from "./ThankYouComposer";

const money = (cents) => `$${(cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const day = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "");

const STATUS = {
  scheduled:   { label: "Scheduled", cls: "bg-tangerine/15 text-tangerine", when: (g) => `for the week ending ${day(g.scheduled_for)}` },
  transferred: { label: "Sent",      cls: "bg-cobalt/15 text-cobalt",       when: (g) => `sent ${day(g.transferred_at)} · arriving in ~2 business days` },
  paid:        { label: "Deposited", cls: "bg-grass/15 text-grass",         when: (g) => `deposited ${day(g.paid_at)}` },
  held:        { label: "On hold",   cls: "bg-ink/10 text-ink",             when: () => "our team will be in touch" },
  failed:      { label: "Failed",    cls: "bg-scarlet/15 text-scarlet",     when: () => "we're looking into it" },
  cancelled:   { label: "Cancelled", cls: "bg-ink/10 text-ink",             when: (g) => day(g.created_at) },
};

/** Compact grant history for the student dashboard, with the thank-you composer per sent grant. */
export const GrantList = ({ grants = [], onRefresh }) => {
  if (!grants.length) return null;
  return (
    <div className="mt-8" data-testid="grant-list">
      <p className="text-[13px] font-semibold uppercase tracking-[0.22em] text-olive">Your grants</p>
      <ul className="mt-3 divide-y divide-ink/10 rounded-lg border-2 border-ink/10 bg-bone">
        {grants.map((g) => {
          const s = STATUS[g.status] || STATUS.scheduled;
          return (
            <li key={g.id} className="px-4 py-3" data-testid={`grant-row-${g.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <p className="font-serif text-3xl text-ink">{money(g.amount_cents)}</p>
                  <p className="mt-0.5 truncate text-[13px] text-olive">
                    {g.campaign_title || "Grant"} · {s.when(g)}
                  </p>
                  {g.memo && <p className="mt-1 text-[13px] italic text-ink/70">“{g.memo}”</p>}
                </div>
                <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-[13px] font-semibold uppercase tracking-[0.14em] ${s.cls}`} data-testid={`grant-status-${g.id}`}>
                  {s.label}
                </span>
              </div>
              <ThankYouComposer grant={g} onPosted={onRefresh} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
